export default __webpack_public_path__ + "assets/bd5ec08914dc99546cc07433812ea5ea.svg";